import { Link } from "react-router-dom";
import React from "react";
import "../styles/CloudDevOps.css";

const cloudServices = [
  { title: "Cloud Foundations", text: "Secure AWS and Azure environments designed around your workloads", number: "01" },
  { title: "Platform Engineering", text: "Reusable developer platforms that make shipping reliable software easier", number: "02" },
  { title: "Delivery Automation", text: "CI/CD pipelines that test, package and release changes with confidence", number: "03" },
  { title: "Reliability & FinOps", text: "Observability and cost controls that keep services healthy as they scale", number: "04" },
];

const CloudDevOps = () => (
  <main className="cloud-page">
    <section className="cloud-hero">
      <div className="cloud-hero-image"><img src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1400&q=90" alt="Cloud infrastructure and global network connections" />
        <div className="cloud-status"><i /> ALL SYSTEMS OPERATIONAL</div>
        <div className="cloud-node cloud-node-a">BUILD <b>✓</b></div><div className="cloud-node cloud-node-b">DEPLOY <b>↗</b></div>
      </div>
      <div className="cloud-hero-copy"><span>ENGINEERED TO SCALE</span><h1>Ship with confidence</h1><p>Build a dependable cloud foundation and a smoother path from code to production. We bring infrastructure, automation and operations together.</p><Link to="/contact">Plan your cloud journey <b>→</b></Link></div>
    </section>

    <section className="cloud-platform">
      <div className="cloud-platform-heading"><span>THE PLATFORM LAYER</span><h2>Infrastructure that gets out of your way</h2><p>Practical cloud and DevOps capabilities for teams that need to move quickly without losing control</p></div>
      <div className="cloud-service-grid">
        {cloudServices.map((item) => <article key={item.number}><span>{item.number}</span><div className="cloud-card-line" /><h3>{item.title}</h3><p>{item.text}</p></article>)}
      </div>
    </section>

    <section className="cloud-delivery">
      <div className="cloud-delivery-copy"><span>FROM COMMIT TO CUSTOMER</span><h2>A delivery flow your team can trust</h2><p>We connect source control, automated checks and deployment practices into a repeatable release process, then make the health of every service visible.</p>
        <div className="cloud-metrics"><div><strong>Automated</strong><small>build and release</small></div><div><strong>Observable</strong><small>service health</small></div><div><strong>Resilient</strong><small>by design</small></div></div>
      </div>
      <div className="cloud-delivery-image"><img src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1100&q=85" alt="Cloud data center infrastructure" loading="lazy" /><div className="cloud-image-caption">Deploy · Observe · Improve</div></div>
    </section>
    <section className="cloud-cta"><div><span>READY FOR A STRONGER FOUNDATION?</span><h2>Let’s make your next release easier</h2></div><Link to="/contact">Talk to a cloud engineer ↗</Link></section>
  </main>
);

export default CloudDevOps;